import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchSharedReport } from "@custom/rtk-apis/report/sharedReportPreview";
// Define the initial state structure
export interface ReportState {
  status: string;
  result: any | null;
  msg: string;
  loading: boolean;
  error: string | null;
}

export const initialState: ReportState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
  error: null,
};

// Create the slice
const getSharedReportSlice = createSlice({
  name: "getSharedReportDetail",
  initialState,
  reducers: {
    revertStatus: (state) => {
      state.status = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSharedReport.pending, (state) => {
        console.log("Pending");
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSharedReport.fulfilled, (state, action: PayloadAction<any>) => {
        console.log("Fulfilled", action.payload);
        state.loading = false;
        state.status = action.payload.status;
        state.result = action.payload.result;
        state.msg = action.payload.msg;
      })
      .addCase(fetchSharedReport.rejected, (state, action: PayloadAction<any>) => {
        console.log("Rejected");
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getSharedReportSlice.reducer;
export const { revertStatus } = getSharedReportSlice.actions;
